import performanceNow from 'performance-now';

export const milliseconds = () => Math.round(performanceNow());
export const now = performanceNow;
